import { createRoot } from 'react-dom/client';
import React, { StrictMode } from 'react';

import Dashboard from "./Dashboard";
import RecentOrders from './RecentOrders';
import PasswordChange from './PasswordChange';

/**
 * @param {Element} element element to inject dashboard into
 */
export function initDashboard(element) {
	const root = createRoot(element);
	root.render(
	<StrictMode>
		<Dashboard />
	</StrictMode>
	);
}

export function initRecentOrders(element) {
	const root = createRoot(element);
	root.render(
	<StrictMode>
		<RecentOrders />
	</StrictMode>
	);
}

export function initPasswordChange(element) {
	const root = createRoot(element);
	root.render(
	<StrictMode>
		<PasswordChange />
	</StrictMode>
	);
}